import { queryOptions, useQuery } from "@tanstack/react-query"
import axios from "axios"
import { CompanyClientsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CompanyClientsResponseDataSchema>>

const companyClientsQuery = () =>
  queryOptions({
    queryKey: ["company-clients"],
    queryFn: async () => {
      const response = await axios.get<Response>("/companies/clients")
      return response.data.data
    },
  })

export const useCompanyClientsQuery = (isEnabled: boolean) =>
  useQuery({ ...companyClientsQuery(), enabled: isEnabled })
